import { render } from "./IconDestinationEmptyPlaceholderImage.vue?vue&type=template&id=63327d54"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconDestinationEmptyPlaceholderImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63327d54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63327d54', __exports__)) {
    api.reload('63327d54', __exports__)
  }
  
  module.hot.accept("./IconDestinationEmptyPlaceholderImage.vue?vue&type=template&id=63327d54", () => {
    api.rerender('63327d54', render)
  })

}


export default __exports__